function testJSON(text) {

  if (typeof text !== "string") {
    return false;
  } else if (text.length === 0) {
    return false;
  }

  // This is to filter our literals such as a number, which is actually valid JSON
  if (   ((text[0] !== '{')               && (text[0] !== '['))
      || ((text[text.length - 1] !== '}') && (text[text.length - 1] !== ']'))) {
    return false;
  }

  try {
      JSON.parse(text);
      return true;
  } catch (error) {
      return false;
  }
}


/*
 * This method removes elements from the arrayToFilter, those items whose attribute
 * values are found in corresponding attributes from the filterArray.
 * Example usage:
 *  const array1 = [
 *    { id: 1, name: 'Item A' },
 *    { id: 2, name: 'Item B' },
 *    { id: 3, name: 'Item C' },
 *    { id: 4, name: 'Item D' },
 *  ];
 *
 *  const array2 = [
 *    { id: 2, name: 'Item B' },
 *    { id: 4, name: 'Item D' },
 *  ];
 *
 *  const filteredArray = filterArray(array1, array2, 'id');
 *  console.log(filteredArray);
 *
 *  Expected Output:
 *  [
 *    { id: 1, name: 'Item A' },
 *    { id: 3, name: 'Item C' },
 *  ]
 */

function filterArray(arrayToFilter, filterArray, attributeName) {
  const valuesToExclude = filterArray.map(item => item[attributeName]);

  return arrayToFilter.filter(item => !valuesToExclude.includes(item[attributeName]));
}


function formatFileSize (input) {
  let formatted;

  if (input        >= (1024.0 * 1024.0 * 1024.0 * 1024.0)) {
    formatted = (Number(input / (1024.0 * 1024.0 * 1024.0 * 1024.0))).toFixed(2) + " TB";
  } else if (input >=          (1024.0 * 1024.0 * 1024.0)) {
    formatted = (Number(input /          (1024.0 * 1024.0 * 1024.0))).toFixed(2) + " GB";
  } else if (input >=                   (1024.0 * 1024.0)) {
    formatted = (Number(input /                   (1024.0 * 1024.0))).toFixed(2) + " MB";
  } else if (input >=                             1024.0) {
    formatted = (Number(input /                             1024.0)).toFixed(2) + " KB";
  } else {
    formatted = (Number(input)).toFixed(0) + " B";
  }

  return (formatted);
}


function isNaturalNumber(str) {
  str = '' + str; // If input is a number, convert to string.
  const n = Math.floor(Number(str));
  return ((n !== Infinity) && (String(n) === str) && (n >= 0));
} 


function isObjectEmpty(obj) {
  return obj && Object.keys(obj).length === 0 && obj.constructor === Object;
}


module.exports = {
  testJSON:        testJSON,
  filterArray:     filterArray,
  formatFileSize:  formatFileSize,
  isNaturalNumber: isNaturalNumber,
  isObjectEmpty:   isObjectEmpty
};
